import { Bike, UploadedDocument } from "models"
import { pageStatusEnum } from "utils"

/**********************
 **** DOCUMENTS ****
 **********************/
// prettier-ignore
export type DocumentsAction = { type: "LOADING" } | { type: "SUCCESS"; documents: UploadedDocument[] } | { type: "ERROR" }
export const DocumentsReducer = (
	state: { documentsStatus: string; documents: UploadedDocument[] },
	action: DocumentsAction
) => {
	switch (action.type) {
		case "LOADING": {
			return {
				documentsStatus: pageStatusEnum.loading,
				documents: state.documents,
			}
		}
		case "SUCCESS": {
			return {
				documentsStatus: pageStatusEnum.complete,
				documents: action.documents,
			}
		}
		case "ERROR": {
			return {
				documentsStatus: pageStatusEnum.errored,
				documents: [],
			}
		}
	}
}

/**********************
 **** BIKES ****
 **********************/
export type BikeAction = { type: "LOADING" } | { type: "SUCCESS"; bike: Bike } | { type: "ERROR" }
export type PageDispatch = (action: BikeAction) => void

export const BikeReducer = (state: any, action: BikeAction) => {
	switch (action.type) {
		case "LOADING": {
			return {
				bikeStatus: pageStatusEnum.loading,
				bike: null,
			}
		}
		case "SUCCESS": {
			return {
				bikeStatus: pageStatusEnum.complete,
				bike: action.bike,
			}
		}
		case "ERROR": {
			return {
				bikeStatus: pageStatusEnum.errored,
				bike: null,
			}
		}
	}
}
